export const ADMIN = ["administrator"];

export const MANAGERS = [
  "operations_manager",
  "account_manager",
  "project_manager",
  "sales_manager",
  "vendor_manager",
  "finance_manager",
  "accountant",
  "office_admin",
  "language_quality_manager",
  "language_lead",
];

export const ADMIN_AND_MANAGERS = [...ADMIN, ...MANAGERS];

// Vendor manager portal - manages vendor records only (vendors, applications,
// contacts, prices, tags). Distinct from the external `vendor` role.
export const VENDOR_MANAGER = ["vendor_manager"];

// Project manager portal - projects/jobs (scoped to accessible clients),
// clients (scoped to client pool), full system values, read-only vendors.
export const PROJECT_MANAGER = ["project_manager"];

// Account manager portal - two modules only: Client and Vendor. Read-only on
// the client & vendor records, receivables and payables; full CRUD on both
// price lists and on all four invoice/payment modules.
export const ACCOUNT_MANAGER = ["account_manager"];

// Admin + project managers: modules a project manager gets full CRUD on but
// other managers do not (system values).
export const ADMIN_AND_PROJECT_MANAGER = [...ADMIN, "project_manager"];

// Admin + managers EXCEPT project managers: modules a project manager may not
// reach at all (client pools, vendor applications, vendor creation).
export const ADMIN_AND_MANAGERS_NO_PM = ADMIN_AND_MANAGERS.filter(
  (r) => r !== "project_manager"
);

// Admin + managers EXCEPT account managers: modules absent from the account
// manager portal (projects, jobs, system values, client pools, managers, to-dos
// and the vendor manager settings screens).
export const ADMIN_AND_MANAGERS_NO_AM = ADMIN_AND_MANAGERS.filter(
  (r) => r !== "account_manager"
);

// Admin + managers EXCEPT project AND account managers - modules neither
// restricted portal may reach (client pools, vendor applications, creating
// vendors).
export const ADMIN_AND_MANAGERS_NO_PM_AM = ADMIN_AND_MANAGERS.filter(
  (r) => r !== "project_manager" && r !== "account_manager"
);

// Accessible to admin, managers and vendors, but not to account managers
// (the /jobs page).
export const ALL_STAFF_NO_AM = [...ADMIN_AND_MANAGERS_NO_AM, "vendor"];

export const VENDOR = ["vendor"];

export const CLIENT = ["client"];

// Accessible to admin, managers, AND vendors (e.g. the /jobs page)
export const ALL_STAFF = [...ADMIN_AND_MANAGERS, ...VENDOR];
